var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "items": _vm.formats,
      "item-value": "id",
      "item-text": "value",
      "label": _vm.$t("format")
    },
    model: {
      value: _vm.store.formInfo.format,
      callback: function ($$v) {
        _vm.$set(_vm.store.formInfo, "format", $$v);
      },
      expression: "store.formInfo.format"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }